// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import SocialLogin from './SocialLogin';
import type { StateProps } from './SocialLogin';
import type { State } from 'types/redux';

import { selectors as userSelectors } from 'store/reducers/user/';
import socialLoginActions from 'store/reducers/user/socialLoginActions';
import { setContactInfo } from 'store/reducers/appointment/contactInfo/actions';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import { getContactInfo } from 'store/reducers/appointment/selectors';
import { sendScheduleServiceAccountCreated } from 'store/reducers/appointment/actions';
import {
  setAppFlow,
  setLoadingAppointment
} from 'store/reducers/userInteractions/actions';
import { gtmUserEvent, gtmStartGenericEvent } from 'store/reducers/gtm/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { sendScheduleServiceLogin } from 'store/reducers/login/actions';

const mapStateToProps = (state: State): $Shape<StateProps> => ({
  isVisible: !userSelectors.isLoggedIn(state),
  countryCode: getDealerCountryCode(state),
  personId: getContactInfo(state).id
});

const mapDispatchToProps = {
  doSocialLogin: socialLoginActions.doSocialLogin,
  postSocialLogin: socialLoginActions.postSocialLogin,
  setContactInfo,
  setLoadingAppointment,
  setAppFlow,
  gtmUserEvent,
  gtmStartGenericEvent,
  sendScheduleServiceLogin,
  goTo,
  sendScheduleServiceAccountCreated
};

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SocialLogin);



// WEBPACK FOOTER //
// ./src/components/pages/User/Social/SocialLogin/SocialLoginContainer.js